import { createSelector } from 'reselect';

import { getCurrentCompanyAge, getRolloutEnabled } from 'selectors/session';

const selectPayrollCustomer = state =>
  !!state.getIn(['session', 'payroll_flags', 'payroll_dashboard']) ||
  !!state.getIn(['session', 'payroll_flags', 'implementation_dashboard']);

const selectCustomerInTrial = state =>
  state.getIn(['session', 'currentCompany', 'hasActiveTrialPeriod']);

const selectPayingCustomer = state =>
  state.getIn(['session', 'currentCompany', 'isPaying']);

const selectCompanyCreatedWithinPast60Days = createSelector(
  getCurrentCompanyAge,
  companyAge => companyAge <= 60
);

// Qualifying Customers should be able to chat, email or request a call from the Help page
export const selectCanContactHomebase = createSelector(
  selectPayrollCustomer,
  selectCustomerInTrial,
  selectPayingCustomer,
  selectCompanyCreatedWithinPast60Days,
  (payrollCustomer, customerInTrial, payingCustomer, createdPast60) =>
    payrollCustomer || customerInTrial || payingCustomer || createdPast60
);

/*
  Current time is within Monday-Friday, 8 AM to 7 PM Central
  and is not thanksgiving, new years, or christmas day
 */
export const selectIsWithinBusinessHours = state =>
  state.get('help').withinBusinessHours;

export const selectIsCheckHoursFulfilled = state =>
  state.get('help').isCheckHoursFulfilled;

export const selectClosestBusinessDay = state =>
  state.get('help').closestBusinessDay;

export const selectClickToRequestCallbackActive = state =>
  getRolloutEnabled(state, 'click_to_request_callback');

export const selectSierraRemoveCallbackLinks = state =>
  getRolloutEnabled(state, 'sierra_remove_callback_links');

export const selectSierraHelpEmployeeChat = state =>
  getRolloutEnabled(state, 'sierra_help_employee_chat');

export const selectRequestCallbackPending = state =>
  state.getIn(['help']).requestCallbackPending;

export const selectRequestCallbackSent = state =>
  state.getIn(['help']).requestCallbackSent;
